import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Button, Grid, Typography, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Alert, TextField } from '@mui/material';
import acledaIcon from "../assets/acleda-icon.png";
import Invoice from "../components/Invoice";

export default function Payment() {
    const [submitLoading, setSubmitLoading] = useState(false);

    const [building, setBuilding] = useState('');
    const [roomNumber, setRoomNumber] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('cash');
    const [showAlert, setShowAlert] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [performPayment, setPerformPayment] = useState(false);
    const [amountInput, setAmountInput] = useState('');
    const [room, setRoom] = useState('');
    const [roomNotFoundError, setRoomNotFoundError] = useState('');
    const [paymentInfo, setPaymentInfo] = useState();
    // =========>> Constant
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();
    const monthYearToUseInUseState = currentMonth.toString() + currentYear.toString();

    // const [monthYear, setMonthYear] = useState(monthYearToUseInUseState);
    const [currency, setCurrency] = useState('USD'); // default to USD
    const [totalMoneyExchange, setTotalMoneyExchange] = useState();
    const [totalMoneyExchangeToDisplay, setTotalMoneyExchangeToDisplay] = useState();
    const [amountCalculation, setAmountCalculation] = useState();
    const [recentRecordData, setRecentRecordData] = useState();

    const [inputMethod, setInputMethod] = useState('keyboard');
    // Alert message
    const [alertVisible, setAlertVisible] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState('success');

    const [showDialog, setShowDialog] = useState(false);  
    const [showErrorDialog, setShowErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({
        id: "",
        previous_water_usage: "",
        current_water_usage: "",
        water_usage_price: "",
        electricity_usage: "",
        garbage: "",
        late_penalty: "",
        vehicle_charge: "",
        room_price_calculating: "",
        old_debt: "",
        total_debt_update: "",
    });

    const [exitingDataFormData, setExitingDataFormData] = useState({
        id: "",
        room_number: "",
        previous_water_usage: "",
        current_water_usage: "",
        electricity_usage: "",
        monthYear: "",
    });
    
    // ========>> Invoice
    const [openInvoiceDialog, setOpenInvoiceDialog] = useState(false);

    // =============>> Changing room
    const [showChangingRoomDialog, setShowChangingRoomDialog] = useState(false);
    const [newRoomNumber, setNewRoomNumber] = useState('');
    const [showChangingRoomEditDataDialog, setShowChangingRoomEditDataDialog] = useState(false);
    const [changingSubmitData, setChangingSubmitData] = useState(false);
    const [changingRoomFormData, setChangingRoomFormData] = useState({
        id: "",
        old_room_number: "",
        new_room_number: "",
        current_water_usage: "",
        electricity_usage: "",
        monthYear: "",
    })

    // ================>> Exiting room
    const [showExitingRoomDialog, setShowExitingRoomDialog] = useState(false);
    const [showExitingRoomChangingDataDialog, setShowExitingRoomChangingDataDialog] = useState(false);
    const [exitingSubmitData, setExitingSubmitData] = useState(false);

    // ================> Entering room
    const [showEnteringRoomDialog, setShowEnteringRoomDialog] = useState(false);
    const [enteringSubmitData, setEnteringSubmitData] = useState(false);

    let monthYearForPaymentInfo;
    if (currentDate.getDate() < 8) {
        let previousMonth = currentMonth - 1;
        let previousYear = currentYear;
        
        if (previousMonth === 0) {
            previousMonth = 12;
            previousYear -= 1;
        }
        monthYearForPaymentInfo = previousMonth.toString() + previousYear.toString();
    } else {  
        monthYearForPaymentInfo = currentMonth.toString() + currentYear.toString();
    }
    const [monthYear, setMonthYear] = useState(monthYearForPaymentInfo);

    const InputMethodToggle = () => (
        <div className="flex justify-center ml-2 md:ml-10">
            <div className="bg-white rounded-lg shadow-md p-2">
                <button
                    onClick={() => setInputMethod('button')}
                    className={`px-2 md:px-4 py-2 rounded-l-lg md:text-lg ${inputMethod === 'button' ? 'bg-secondary1 text-white' : 'bg-gray-200'}`}
                >
                    ប្រើប៊ូតុង
                </button>
                <button
                    onClick={() => setInputMethod('keyboard')}
                    className={`px-2 md:px-4 py-2 rounded-r-lg md:text-lg ${inputMethod === 'keyboard' ? 'bg-secondary1 text-white' : 'bg-gray-200'}`}
                >
                    ប្រើក្តារចុច
                </button>
            </div>
        </div>
    );

    useEffect(() => {
        if (inputMethod === 'keyboard') {
            const handleKeyPress = (e) => {
                if (!performPayment) {
                    // Building input (A-Z)
                    if (/^[A-Za-z]$/.test(e.key) && !building) {
                        const upperKey = e.key.toUpperCase();
                        if (['A', 'B', 'C', 'D', 'H', 'K', 'N', 'R'].includes(upperKey)) {
                            setBuilding(upperKey);
                        }
                    }
                    // Room number input (0-9)
                    else if (/^[0-9]$/.test(e.key) && building && roomNumber.length < 2) {
                        setRoomNumber(prev => prev + e.key);
                    }
                } else {
                    // Amount input for payment screen
                    if (/^[0-9.]$/.test(e.key)) {
                        setAmountInput(prev => prev + e.key);
                    }
                }
            };

            const handleBackspace = (e) => {
                if (e.key === 'Backspace') {
                    if (performPayment) {
                        setAmountInput(prev => prev.slice(0, -1));
                    } else if (roomNumber) {
                        setRoomNumber(prev => prev.slice(0, -1));
                    } else if (building) {
                        setBuilding('');
                    }
                }
            };

            window.addEventListener('keypress', handleKeyPress);
            window.addEventListener('keydown', handleBackspace);

            return () => {
                window.removeEventListener('keypress', handleKeyPress);
                window.removeEventListener('keydown', handleBackspace);
            };
        }
    }, [inputMethod, building, roomNumber, performPayment]);

    const handleBuildingClick = (letter) => {
      setBuilding(letter);
      setOpenDialog(false);
    };
  
    const handleRoomNumberClick = (number) => {
      setRoomNumber(prevRoomNumber => {
        if (prevRoomNumber.length < 2) {
            setOpenDialog(false);
          return prevRoomNumber + number;
        }
        return prevRoomNumber;
      });
    };
  
    const handleRoomSubmit = (e) => {
        e.preventDefault();
        if (!building || !roomNumber) {
          setOpenDialog(true); // Open the dialog if validation fails
        } else {
          // Handle form submission, e.g., navigate to the payment page
          setPerformPayment(true);
        }
    };
  
    const handleResetRoomNumber = () => {
      setRoomNumber('');
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
    };

    const handleButtonClick = (value) => {
        const nextValue = amountInput + value; 
        setAmountInput(nextValue);
        // calculation(nextValue); 
    };
    
    const handleDelete = () => {
        const nextValue = amountInput.slice(0, -1); 
        setAmountInput(nextValue);
        calculation(nextValue);
    };
  
    const handleReset = () => {
        setAmountInput('');
    };
    
    const handleArrowBack = () => {
        setPerformPayment(false);
        calculation();
    }

    const handleInvoiceDialogClose = () => {
        setOpenInvoiceDialog(false);
    }

    const handleOpenInvoice = () => {
        setOpenInvoiceDialog(true);
    }
    // ==================>> Fetch API
    const handlePaymentInfo = (e) => {
        e.preventDefault();
        getPaymentInfo();
        setExitingSubmitData(false);
    }
    const getPaymentInfo = async () => {
        setExitingSubmitData(false);
        setEnteringSubmitData(false);
        setChangingSubmitData(false);
        setAmountInput('');
        recentRecord();
        setMonthYear(monthYearForPaymentInfo);
        if (!building || !roomNumber) {
          setOpenDialog(true); // Open the dialog if validation fails
        } else {
            const room_number = building + roomNumber;
            // let monthYearForPaymentInfo;
            // if (currentDate.getDate() < 10) {
            //     let previousMonth = currentMonth - 1;
            //     let previousYear = currentYear;
                
            //     if (previousMonth === 0) {
            //       previousMonth = 12;
            //       previousYear -= 1;
            //     }
            //     monthYearForPaymentInfo = previousMonth.toString() + previousYear.toString();
            // } else {  
            //     monthYearForPaymentInfo = currentMonth.toString() + currentYear.toString();
            // }
            setRoom(room_number);
            try {
                const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment/payment-data-details?monthYear=${monthYear}&room_number=${room_number}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });
    
                if (!response.ok) {
                    const errorData = await response.json();
                    setOpenDialog(true);
                    setRoomNotFoundError(errorData.message);
                    throw new Error(errorData.message);
                }
    
                const data = await response.json();
                setPaymentInfo(data);
                // total is USD by default
                // const total = Number(data.price) + Number(data.total_amount) / 4000 + Number(data.late_penalty) + Number(data.old_debt);
                setTotalMoneyExchange(data.total_debt);
                setTotalMoneyExchangeToDisplay(Number(data.total_debt));
                setPerformPayment(true);
            } catch (err) {
                console.error(err.message);
            }
        }
    };

    const recentRecord = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment/recent-records`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                setOpenDialog(true);
                setRoomNotFoundError(errorData.message);
            }
            const data = await response.json();
            setRecentRecordData(data);
        } catch (err) {
            console.error(err.message);
        }
    }

    useEffect(() => {
        recentRecord();
    }, []);

    useEffect(() => {}, [recentRecordData]);
    
    const handlePaymentSubmit = () => {
        if (!amountInput) {
            setOpenDialog(true);
            setRoomNotFoundError("សូមបញ្ចូលតម្លៃ");
            return;
        }

        const total_debt_exchange = currency == "USD" ? paymentInfo.total_debt : paymentInfo.total_debt * 4000;
        // Submit the input value to the API

        const data = { 
            room_number: paymentInfo.room_number,
            amount: (Number(amountCalculation) < 0) ? Number(total_debt_exchange) + Number(amountCalculation) : Number(total_debt_exchange), 
            currency: currency,
            payment_method: paymentMethod,
            monthYear: monthYear
        };

        fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        .then((response) => {
            if (!response.ok) {
                return response.json().then((data) => {
                    console.log("Error Data:", data); // Debugging
                    setAlertMessage(typeof data.message === 'string' ? data.message : 'Something went wrong');
                    setAlertSeverity("error");
                    setAlertVisible(true);
                    setTimeout(() => {
                        setAlertVisible(false);
                    }, 2000);
                    throw data;
                });
            }
            return response.json();
        })
        .then(() => {
            recentRecord();
            setAlertMessage(`ទិន្នន័យត្រូវបានបញ្ចូលដោយជោគជ័យ`);
            setAlertSeverity("success");    
            setAlertVisible(true);
            setAmountInput("");
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000);
        })
        .catch((error) => {
            console.log("Catch Error:", error); // Debugging
            setAlertMessage(
                typeof error.message === 'string'
                    ? error.message
                    : 'An unexpected error occurred'
            );
            setAlertSeverity("error");
            setAlertVisible(true);
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000);
        });        
    };

    // Handle form input changes
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => {
            const updatedFormData = { ...prevFormData, [name]: value };
    
            if (name === 'previous_water_usage' || name === 'current_water_usage') {
                const previousWaterUsage = parseFloat(updatedFormData.previous_water_usage) || 0;
                const currentWaterUsage = parseFloat(updatedFormData.current_water_usage) || 0;
                updatedFormData.water_usage_price = (currentWaterUsage - previousWaterUsage) * 2000;
            }
    
            return updatedFormData;
        });
    };

    const handleEditOpen = () => {
        setShowDialog(true);
        setFormData({
            id: paymentInfo.id,
            room_number: paymentInfo.room_number,
            previous_water_usage: Number(paymentInfo.previous_water_usage),
            current_water_usage: Number(paymentInfo.current_water_usage),
            water_usage_price: Number(paymentInfo.water_usage_price),
            electricity_usage: (Number(paymentInfo.electricity_usage) > 0) ? Number(paymentInfo.electricity_usage) - 1000 : 0,
            garbage: Number(paymentInfo.garbage),
            late_penalty: Number(paymentInfo.late_penalty),
            vehicle_charge: Number(paymentInfo.vehicle_charge),
            room_price_calculating: Number(paymentInfo.price),
            old_debt: Number(paymentInfo.old_debt),
            total_debt_update: Number(paymentInfo.total_debt),
        });
    }

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        
        // Validation checks
        const validationChecks = [
            { field: 'previous_water_usage', message: "សូមបញ្ចូលទឹកខែចាស់" },
            { field: 'current_water_usage', message: "សូមបញ្ចូលទឹកខែថ្មី" },
            { field: 'electricity_usage', message: "សូមបញ្ចូលតម្លៃភ្លើង" },
            { field: 'late_penalty', message: "សូមបញ្ចូលថ្លៃពិន័យ" }
        ];
    
        for (const check of validationChecks) {
            if (formData[check.field].length === 0) {
                setErrorMessage(check.message);
                setShowErrorDialog(true);
                return;
            }
        }
    
        try {
            const updatedFormData = {
                ...formData,
                late_penalty: Number(formData.late_penalty),
                room_price_calculating: Number(formData.room_price_calculating),
            };
    
            const response = await fetch(
                `${process.env.REACT_APP_API_ENDPOINT}/monthly-report/payment/${formData.id}`,
                {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(updatedFormData),
                }
            );
    
            if (!response.ok) {
                const errorData = await response.json();
                setAlertMessage(errorData.message);
                setAlertSeverity("error");
                setAlertVisible(true);
                setTimeout(() => {
                    setAlertVisible(false);
                }, 2000);
                throw new Error(errorData.message);
            }
    
            const data = await response.json();
            setPaymentInfo(data);
            setTotalMoneyExchange(data.total_debt);
            setTotalMoneyExchangeToDisplay(Number(data.total_debt));
            
            // Success handling
            setShowDialog(false);
            setAlertMessage("ទិន្នន័យត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ");
            setAlertSeverity("success");
            setAlertVisible(true);
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000);
    
        } catch (error) {
            setAlertMessage("ទិន្នន័យត្រូវបានធ្វើបច្ចុប្បន្នភាពបរាជ័យ");
            setAlertSeverity("error");
            setAlertVisible(true);
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000);
        }
    };

    const handleChangingRoomOpen = (e) => {
        e.preventDefault();
        setShowChangingRoomDialog(true);
    }

    const handleNewRoomNumber = (event) => {
        setNewRoomNumber(event.target.value);
    };

    const handleShowChangingRoomEditDataDialogOpen = () => {
        if (newRoomNumber.length === 0) {
            setErrorMessage("សូមបញ្ចូលលេខបន្ទប់ដែលត្រូវប្តូរទៅ");
            setShowErrorDialog(true);
            return;
        }

        setShowChangingRoomDialog(false);
        let monthYearNew;
        if (currentDate.getDate() < 10) {
            let previousMonth = currentMonth - 1;
            let previousYear = currentYear;
            
            if (previousMonth === 0) {
              previousMonth = 12;
              previousYear -= 1;
            }
            monthYearNew = previousMonth.toString() + previousYear.toString();
        } else {  
            monthYearNew = currentMonth.toString() + currentYear.toString();
        }
        setMonthYear(monthYearNew);
        setChangingRoomFormData({
            id: paymentInfo.id,
            old_room_number: paymentInfo.room_number,
            new_room_number: newRoomNumber,
            previous_water_usage: Number(paymentInfo.previous_water_usage),
            current_water_usage: Number(paymentInfo.current_water_usage),
            electricity_usage: (Number(paymentInfo.electricity_usage) > 0) ? Number(paymentInfo.electricity_usage) - 1000 : 0,
            monthYear: monthYearNew
        });
        setShowChangingRoomEditDataDialog(true);
    };

    const handleChangingRoomInputChange = (e) => {
        const { name, value } = e.target;
        setChangingRoomFormData((prevData) => ({
            ...prevData,
            [name]: value, 
        }));
    };

    const handleChangingRoomSubmit = () => {
        setSubmitLoading(true);
        console.log(changingRoomFormData)
        if (changingRoomFormData.previous_water_usage.length === 0) {
            setErrorMessage("សូមបញ្ចូលទឹកខែចាស់");
            setShowErrorDialog(true);
            return;
        }

        if (changingRoomFormData.current_water_usage.length === 0) {
            setErrorMessage("សូមបញ្ចូលទឹកខែថ្មី");
            setShowErrorDialog(true);
            return;
        }

        if (changingRoomFormData.electricity_usage.length === 0) {
            setErrorMessage("សូមបញ្ចូលតម្លៃភ្លើង");
            setShowErrorDialog(true);
            return;
        }

        fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment/change-room`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(changingRoomFormData),
        })
        .then(async (response) => { // Add `async` here
            if (!response.ok) {
                setSubmitLoading(false);
                const data = await response.json(); // Await JSON parsing
                console.log("Error Data:", data); 
                setOpenDialog(true);
                setRoomNotFoundError(typeof data.message === 'string' ? data.message : 'Something went wrong');
                throw data;
            }
            const changingRoomData = await response.json();
            setPaymentInfo("");
            setPaymentInfo(changingRoomData);
            setTotalMoneyExchange(changingRoomData.total_debt);
            setTotalMoneyExchangeToDisplay((changingRoomData.total_debt));
            setChangingSubmitData(true);
            setSubmitLoading(false);
            setShowChangingRoomEditDataDialog(false);
        })
        .then(() => {
            setAmountInput("");
        })
        .catch((error) => {
            setSubmitLoading(false);
            setOpenDialog(true);
            setRoomNotFoundError(typeof error.message === 'string'
                ? error.message
                : 'An unexpected error occurred');
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000);
        })  
    }

    const handleExitingRoomOpen = (e) => {
        let monthYearExiting;
        if (currentDate.getDate() < 10) {
            let previousMonth = currentMonth - 1;
            let previousYear = currentYear;
            
            if (previousMonth === 0) {
              previousMonth = 12;
              previousYear -= 1;
            }
            monthYearExiting = previousMonth.toString() + previousYear.toString();
        } else {  
            monthYearExiting = currentMonth.toString() + currentYear.toString();
        }
        monthYearForPaymentInfo = monthYearExiting;
        e.preventDefault();
        setMonthYear(monthYearExiting);
        setExitingDataFormData({
            id: paymentInfo.id,
            room_number: paymentInfo.room_number,
            previous_water_usage: Number(paymentInfo.previous_water_usage),
            current_water_usage: Number(paymentInfo.current_water_usage),
            electricity_usage: Number(paymentInfo.electricity_usage) > 1000 ? Number(paymentInfo.electricity_usage) - 1000 : 0,
            monthYear: monthYearExiting
        });
        setShowExitingRoomDialog(true);
    } 

    // Handle exiting room form input changes
    const handleExitingRoomInputChange = (e) => {
        const { name, value } = e.target;
        setExitingDataFormData((prevData) => ({
            ...prevData,
            [name]: value, 
        }));
    };

    const handleShowExitingRoomChangingDataOpen = () => {
        setShowExitingRoomDialog(false);
        setShowExitingRoomChangingDataDialog(true);
    }

    const handleExitingSubmit = () => {
        setSubmitLoading(true);
        setEnteringSubmitData(false);
        if (exitingDataFormData.previous_water_usage.length === 0) {
            setErrorMessage("សូមបញ្ចូលទឹកខែចាស់");
            setShowErrorDialog(true);
            return;
        }

        if (exitingDataFormData.current_water_usage.length === 0) {
            setErrorMessage("សូមបញ្ចូលទឹកខែថ្មី");
            setShowErrorDialog(true);
            return;
        }

        if (exitingDataFormData.electricity_usage.length === 0) {
            setErrorMessage("សូមបញ្ចូលតម្លៃភ្លើង");
            setShowErrorDialog(true);
            return;
        }

        fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment/tenant-exit`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(exitingDataFormData),
        })
        .then(async (response) => { // Add `async` here
            if (!response.ok) {
                setSubmitLoading(false);
                const data = await response.json(); // Await JSON parsing
                console.log("Error Data:", data); 
                setOpenDialog(true);
                setRoomNotFoundError(typeof data.message === 'string' ? data.message : 'Something went wrong');
                throw data;
            }
            const exitingRoomData = await response.json();
            setPaymentInfo("");
            setPaymentInfo(exitingRoomData);
            setTotalMoneyExchange(exitingRoomData.total_debt);
            setTotalMoneyExchangeToDisplay(Number(exitingRoomData.total_debt));
            setExitingSubmitData(false);
            setSubmitLoading(false);
            setShowExitingRoomChangingDataDialog(false);
        })
        .then(() => {
            setAmountInput("");
        })
        .catch((error) => {
            setSubmitLoading(false);
            setOpenDialog(true);
            setRoomNotFoundError(typeof error.message === 'string'
                ? error.message
                : 'An unexpected error occurred');
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000);
        })       
    };

    // =====================================================>> Entering room
    const handleEnteringingRoomOpen = (e) => {
        e.preventDefault();
        setShowEnteringRoomDialog(true);
    }

    const handleEnteringRoomSubmit = () => {
        // setExitingSubmitData(false);
        setSubmitLoading(true); 
        let monthYearEntering;
        if (currentDate.getDate() < 10) {
            let previousMonth = currentMonth - 1;
            let previousYear = currentYear;
            
            if (previousMonth === 0) {
              previousMonth = 12;
              previousYear -= 1;
            }
            monthYearEntering = previousMonth.toString() + previousYear.toString();
        } else {  
            monthYearEntering = currentMonth.toString() + currentYear.toString();
        }  
        const enteringRoomNumber = {
            room_number: paymentInfo.room_number,
            monthYear: monthYearEntering
        }     

        fetch(`${process.env.REACT_APP_API_ENDPOINT}/payment/tenant-enter`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(enteringRoomNumber),
        })
        .then(async (response) => { // Add `async` here
            if (!response.ok) {
                setSubmitLoading(false);
                const data = await response.json(); // Await JSON parsing
                console.log("Error Data:", data); 
                setOpenDialog(true);
                setRoomNotFoundError(typeof data.message === 'string' ? data.message : 'Something went wrong');
                throw data;
            }
            const enteringRoomData = await response.json();
            setPaymentInfo("");
            setPaymentInfo(enteringRoomData);
            setTotalMoneyExchange(enteringRoomData.total_debt);
            setTotalMoneyExchangeToDisplay(Number(enteringRoomData.total_debt));
            setSubmitLoading(false);
            setShowEnteringRoomDialog(false);
            setEnteringSubmitData(true);
        })
        .then(() => {
            setAmountInput("");
        })
        .catch((error) => {
            setSubmitLoading(false);
            setOpenDialog(true);
            setRoomNotFoundError(typeof error.message === 'string'
                ? error.message
                : 'An unexpected error occurred');
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000);
        })       
    }

    const handlePaymentMethod = () => {
        setPaymentMethod((prevMethod) => (prevMethod === 'cash' ? 'acleda' : 'cash'));
    }

    const handleCurrencyToggle = () => {
        setCurrency((prevCurrency) => (prevCurrency === 'USD' ? 'KHR' : 'USD'));
        setAmountInput('');
        let total;
        if (currency == 'KHR') {
            total = totalMoneyExchange / 4000;
        } else {
            total = totalMoneyExchange * 4000;
        }
        setTotalMoneyExchange(total);
        setTotalMoneyExchangeToDisplay(total.toLocaleString());
    };

    const calculation = (input) => {
        const currentAmountInput = input === '' ? 0 : Number(input);
        let x;
        if (totalMoneyExchange < 0) {
            x = Number((-(Number(totalMoneyExchange) - Number(currentAmountInput))).toFixed(3)); 
        } else {
            x = Number((Number(currentAmountInput) - Number(totalMoneyExchange)).toFixed(3));
        }
        setAmountCalculation(x);
    };

    useEffect(() => {
        calculation(amountInput);
    }, [amountInput])
    return (
        <div className="w-full h-[100dvh] bg-white">
            {/* Header */}
            <div className="w-full h-[8dvh] bg-primary2 text-white flex  items-center">
                <div className="md:w-[8%] pl-3 md:pl-10 items-center flex">
                    {!performPayment ? (
                    <NavLink to='/'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                        </svg>
                    </NavLink>) : (
                        <button onClick={handleArrowBack}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                        </svg>
                    </button>
                    )}
                </div>
                <div className="w-[84%] flex justify-center">
                    <h2 className="text-2xl font-semibold">ទូទាត់ប្រាក់</h2>
                </div>
            </div>

            {/* Body */}
            {!performPayment ? (
            <div className="w-full flex flex-col md:px-16 justify-center items-center pb-2">
                <div className="w-full text-start flex items-center my-3 md:mt-5 md:mb-0 md:pl-7">
                    <h2 className="text-base sm:text-xl pl-2 md:pl-5 md:text-2xl font-medium md:mt-4 md:my-4 flex"><span className="hidden sm:flex">ជ្រើសរើស</span>បន្ទប់</h2>
                    <div className="text-xl md:text-2xl font-medium border w-[40%] md:w-[60%] ml-2 md:ml-10 py-1 items-center md:py-2 border-[#d9d9d9] px-5 rounded-lg h-10 md:h-12"><strong>{building}{roomNumber}</strong></div>
                    <InputMethodToggle/>
                </div>
                <div className="lg:w-[90%] flex justify-center xl:w-[80%]">
                    <form onSubmit={handleRoomSubmit} className="space-y-6 w-full">
                        <div className="flex flex-col md:flex-row justify-center items-center md:items-stretch space-y-5 md:space-y-0 md:space-x-8 w-full md:mt-3">
                        {/* Building Selection */}
                        <div className="text-center md:mr-7 w-[70%] md:w-[50%] xl:w-[40%] border-2 py-4 md:py-5 flex flex-col items-center md:items-stretch md:pl-5 lg:pl-10 pr-2 shadow-custom-shadow rounded-lg">
                            <h3 className="text-xl md:text-3xl 2xl:text-2xl font-semibold mb-3 md:mb-8">អគារ</h3>
                            <div className="grid grid-cols-3 gap-6">
                            {['A', 'B', 'C', 'D', 'H', 'K', 'N', 'R'].map((letter) => (
                                <button
                                type="button"
                                key={letter}
                                onClick={() => handleBuildingClick(letter)}
                                className={`w-12 h-10 md:w-16 md:h-16 lg:w-20 lg:h-20 2xl:h-[4.5rem] rounded-lg lg:rounded-2xl border border-gray-300 text-2xl flex items-center justify-center font-medium ${
                                    building === letter ? 'bg-secondary1' : 'bg-gray-300'
                                }`}
                                >
                                {letter}
                                </button>
                            ))}
                            </div>
                        </div>

                        {/* Room Number Selection */}
                        <div className="text-center w-[70%] md:w-[50%] xl:w-[40%] border-2 py-3 md:py-5 flex flex-col items-center md:items-stretch md:pl-5 lg:pl-10 pr-2 shadow-custom-shadow rounded-lg">
                            <h3 className="text-xl md:text-3xl 2xl:text-2xl font-semibold mb-3 md:mb-8">បន្ទប់</h3>
                            <div className="grid grid-cols-3 gap-6">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
                                <button
                                type="button"
                                key={number}
                                onClick={() => handleRoomNumberClick(number.toString())}
                                className={`w-12 h-10 md:w-16 md:h-16 lg:w-20 lg:h-20 2xl:h-[4.5rem] text-3xl rounded-lg lg:rounded-2xl border border-gray-300 flex items-center justify-center font-medium ${
                                    roomNumber.includes(number.toString()) ? 'bg-secondary1' : 'bg-gray-300'
                                }`}
                                >
                                {number}
                                </button>
                            ))}
                            </div>
                            <div className="grid grid-cols-3 gap-4 mt-6">
                                <div></div>
                            {[0].map((number) => (
                                <button
                                type="button"
                                key={number}
                                onClick={() => handleRoomNumberClick(number.toString())}
                                className={`w-12 h-10 md:w-16 md:h-16 lg:w-20 lg:h-20 text-3xl rounded-lg lg:rounded-2xl border border-gray-300 flex items-center justify-center ${
                                    roomNumber.includes(number.toString()) ? 'bg-secondary1' : 'bg-gray-300'
                                }`}
                                >
                                {number}
                                </button>
                            ))}
                            </div>
                        </div>
                        </div>

                        <div className="text-center flex justify-center">
                            <button
                                type="button"
                                onClick={handleResetRoomNumber}
                                className="px-8 md:px-16 py-4 md:py-4 text-base md:text-2xl font-medium bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 mr-4"
                            >
                                ជ្រើសរើសបន្ទប់ឡើងវិញ
                            </button>
                            <button
                                type="submit"
                                className="px-14 md:px-28 py-1 md:py-4 text-base md:text-2xl font-medium bg-secondary1 text-white  rounded-lg hover:bg-primary2"
                                onClick={handlePaymentInfo}
                            >
                                បន្ទាប់
                            </button>

                            {/* Alert */}
                            {/* Dialog for Validation */}
                            <Dialog open={openDialog} onClose={handleDialogClose}>
                                <DialogTitle sx={{ fontFamily: "'Kantumruy Pro', sans-serif", fontSize: '24px' }} color="#c50000">ការប្រមាន</DialogTitle>
                                <DialogContent>
                                    <DialogContentText sx={{ fontFamily: "'Kantumruy Pro', sans-serif", fontSize: '20px' }}>
                                        {roomNotFoundError ? roomNotFoundError : 'សូមជ្រើសរើសអគារ និងបន្ទប់' }
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleDialogClose} color="primary"  sx={{ fontFamily: "'Inter', sans-serif", fontSize: '20px' }}>
                                    OK
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </form>
                </div>
            </div>) : (
            <div className="flex py-5 md:py-9 pr-2 md:px-8 space-x-5">
                
                <div className="bg-white border-2 p-4 rounded-md shadow-md md:w-48 lg:w-[20%] hidden sm:flex sm:flex-col">
                    <h3 className="text-center font-semibold mb-4 text-xl">ប្រវត្តិទូទាត់</h3>
                    <ul className="text-left ml-2 lg:ml-5 space-y-2 lg:space-y-4 text-lg lg:text-xl font-medium">
                        {recentRecordData ? (
                            recentRecordData.map((data, index) => (
                                <li key={index}>{data.room.room_number} = {Number(data.amount).toLocaleString('en-US')}{data.currency === 'USD' ? '$' : '៛'}</li>
                            ))
                        ) : (
                            <li>No recent history.</li>
                        )}
                        <li>
                            <NavLink to="/payment-report">
                                <button className="flex space-x-2 items-center lg:space-x-3 bg-secondary1 text-white py-1 px-3 lg:px-6 rounded-xl">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4 lg:size-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                    </svg>
                                    <span className="text-sm lg:text-base">មើលច្រើនទៀត</span>
                                </button>
                            </NavLink>
                        </li>
                    </ul>
                </div>
                <div className="w-[100%] md:w-[80%]">
                    {/* Right Side Room Information */}
                    <div className="flex md:mx-4 space-x-5">
                        <div className="bg-white border-2 px-4 pt-3 pb-0.5 md:py-3 items-center rounded-lg shadow-custom-shadow mx-0 w-[30%]">
                            {!changingSubmitData ? 
                                <h3 className="font-semibold md:text-xl">បន្ទប់: {paymentInfo.room_number}</h3> :
                                <h3 className="font-semibold md:text-xl">ពីបន្ទប់: {paymentInfo.old_room_number} ទៅ {paymentInfo.room_number}</h3>
                            }
                        </div>
                        <div className="bg-white border-2 px-4 pt-3 pb-0.5 md:py-3 items-center rounded-lg shadow-md mx-0 w-[70%]">
                            {!changingSubmitData ?
                                (<h3 className="font-semibold md:text-xl">តម្លៃសរុប: {paymentInfo.price !== undefined && paymentInfo.price !== null && paymentInfo.total_debt !== 0 ? Number(paymentInfo.price) : 0}$ {enteringSubmitData ? <span>+ {paymentInfo.total_amount !== undefined && paymentInfo.total_amount !== null ? Number(paymentInfo.total_amount).toLocaleString('en-US') : 0}៛ + {paymentInfo.refundable_deposit !== undefined && paymentInfo.refundable_deposit !== null ? Number(paymentInfo.refundable_deposit) : 0}៛</span> : <span>+ {paymentInfo.total_amount !== undefined && paymentInfo.total_amount !== null ? Number(paymentInfo.total_amount).toLocaleString('en-US') : 0}៛ {paymentInfo.refundable_deposit !== undefined && paymentInfo.refundable_deposit !== null && <span> - {Number(paymentInfo.refundable_deposit)}៛</span>}
                                    {paymentInfo.late_penalty !== undefined && paymentInfo.late_penalty !== null && paymentInfo.total_debt !== 0 ? <span className="text-red-500"> + {Number(paymentInfo.late_penalty)}$</span>: <span className="text-red-500"></span>} {Number(paymentInfo.old_debt) !== 0  ? (<span className="text-red-500"> + បំណុលចាស់: {Number(Number(paymentInfo.old_debt).toFixed(2)).toLocaleString('en-US')}$</span>): <span className="text-red-500"></span>}</span>} 
                                </h3>) :
                                // (<h3 className="font-semibold md:text-xl">បំណុលចាស់: {paymentInfo.old_total_debt !== undefined && paymentInfo.old_total_debt !== null ? Number(paymentInfo.old_total_debt).toString() : 0}$ + បង់បន្ថែម: {paymentInfo.additional_charging !== undefined && paymentInfo.additional_charging !== null ? Number(paymentInfo.additional_charging).toString() : 0}$ {paymentInfo.refundable_deposit !== undefined && paymentInfo.refundable_deposit !== null ? <span>- ប្រាក់កក់: {Number(paymentInfo.refundable_deposit)}$</span> : <span></span>}
                                // {paymentInfo?.old_refundable_deposit !== undefined && paymentInfo.old_refundable_deposit !== null ? <span>- ប្រាក់កក់ចាស់: {Number(paymentInfo.old_refundable_deposit)}$</span> : <span></span>}
                                // {paymentInfo?.new_refundable_deposit !== undefined && paymentInfo.new_refundable_deposit !== null ? <span> + ប្រាក់កក់ថ្មី: {Number(paymentInfo.new_refundable_deposit)}$</span> : <span></span>}
                                // </h3>)
                                (<h3 className="font-semibold md:text-xl">តម្លៃបន្ទប់ចាស់: {paymentInfo.old_room_price !== undefined && paymentInfo.old_room_price !== null ? Number(paymentInfo.old_room_price).toString() : 0}$ + {paymentInfo.total_amount !== undefined && paymentInfo.total_amount !== null ? Number(paymentInfo.total_amount).toLocaleString('en-US') : 0}៛
                                - {paymentInfo.old_refundable_deposit !== undefined && paymentInfo.old_refundable_deposit !== null ? Number(paymentInfo.old_refundable_deposit) + "៛" : 0} {paymentInfo.late_penalty !== undefined && paymentInfo.late_penalty !== null && paymentInfo.total_debt !== 0 ? <span className="text-red-500"> + {Number(paymentInfo.late_penalty)}$</span>: <span className="text-red-500"></span>} <br />
                                តម្លៃបន្ទប់ថ្មី: {paymentInfo.new_room_price !== undefined && paymentInfo.new_room_price !== null ? Number(paymentInfo.new_room_price).toString() : 0}$
                                {paymentInfo?.new_refundable_deposit !== undefined && paymentInfo.new_refundable_deposit !== null ? <span>+ {paymentInfo.new_total_amount !== undefined && paymentInfo.new_total_amount !== null ? Number(paymentInfo.new_total_amount) : 0}៛ + {Number(paymentInfo.new_refundable_deposit)}៛</span> : <span></span>}
                                </h3>)
                            }
                            {/* {
                                enteringSubmitData ? 
                                (<h3 className="font-semibold md:text-xl">តម្លៃសរុប: {paymentInfo.price !== undefined && paymentInfo.price !== null && paymentInfo.total_debt !== 0 ? Number(paymentInfo.price) : 0}$ {}

                            } */}
                        </div>
                    </div>
                    <div className="flex md:mx-4 mt-4 space-x-5">
                        <button className="flex bg-primary1 rounded-xl py-2 pl-2 pr-1 lg:px-3 text-white text-sm justify-center items-center w-[50%]" onClick={handleOpenInvoice}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                            </svg>
                            <span className="hidden lg:flex ml-2 font-medium">មើលវិក័យប័ត្រ</span>
                        </button>
                        <button className="flex bg-blue-700 rounded-xl py-1.5 pl-2 pr-1 lg:px-3 text-white text-sm justify-center items-center mr-3 w-[50%]" onClick={handleEditOpen}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="size-4">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
                            </svg>
                            <span className="hidden lg:flex ml-2 font-medium">កែប្រែ</span>
                        </button>
                        <button className="flex bg-red-700 rounded-xl py-1.5 pl-2 pr-1 lg:px-3 text-white text-sm justify-center items-center w-[50%]" onClick={handleExitingRoomOpen}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                            </svg>
                            <span className="hidden lg:flex ml-2 font-medium">ចេញ</span>
                        </button>
                        <button className="flex bg-green-700 rounded-xl py-1.5 pl-2 pr-1 lg:px-3 text-white text-sm justify-center items-center mr-3 w-[50%]" onClick={handleEnteringingRoomOpen}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15M12 9l3 3m0 0-3 3m3-3H2.25" />
                            </svg>
                            <span className="hidden lg:flex ml-2 font-medium">ចូល</span>
                        </button>
                        <button className="flex bg-yellow-700 rounded-xl py-1.5 pl-2 pr-1 lg:px-3 text-white text-sm justify-center items-center w-[50%]" onClick={handleChangingRoomOpen}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                            </svg>
                            <span className="hidden lg:flex ml-2 font-medium">ប្តូរបន្ទប់</span>
                        </button>
                    </div>
                    <div className="flex flex-col md:mx-4 mt-4 justify-between space-y-5">
                        <div className="flex md:w-full  mb-4 md:mb-0">
                            <div className="flex items-center w-[50%] mr-2 md:mr-5">
                                <h3 className="font-semibold md:text-lg lg:text-xl w-[20%] mr-2 md:mr-0">ត្រូវបង់</h3>
                                <div className="bg-white border-2 py-2 px-2 md:px-4 md:py-3 rounded-md shadow-md w-[80%] mr-5 font-semibold md:text-lg lg:text-xl"> {paymentInfo.total_debt !== undefined && paymentInfo.total_debt !== null ? totalMoneyExchangeToDisplay : 0}{currency === 'USD' ? '$' : '៛'} </div>
                            </div>
                            <div className="flex items-center w-[50%]">
                                <h3 className="font-semibold text-sm md:text-lg lg:text-xl w-[20%]">បានទទួល</h3>
                                <div className="bg-white border-2 py-2 px-2 md:px-4 md:py-3 rounded-md shadow-md w-[80%] font-semibold md:text-lg lg:text-xl"> {amountInput ? Number(amountInput).toLocaleString('en-US') : 0}{currency === 'USD' ? '$' : '៛'} </div>
                            </div>
                        </div>
                        <div className="flex md:w-full  mb-4 md:mb-0">
                            <div className="flex items-center w-[50%] mr-2 mdmr-5">
                                <h3 className="font-semibold text-sm md:text-lg lg:text-xl w-[20%] mr-1 md:mr-0">នៅខ្វះ​</h3>
                                <div className="bg-white border-2 py-2 px-2 md:px-4 md:py-3 rounded-md shadow-md w-[80%] mr-5 font-semibold md:text-lg lg:text-xl"> {amountCalculation < 0 ? Number((-amountCalculation).toFixed(3)).toLocaleString('en-US') : 0}{currency === 'USD' ? '$' : '៛'} </div>
                            </div>
                            <div className="flex items-center w-[50%]">
                                <h3 className="font-semibold text-sm md:text-lg lg:text-xl w-[20%]">ប្រាក់អាប់</h3>
                                <div className="bg-white border-2 py-2 px-4 md:px-4 md:py-3 rounded-md shadow-md w-[80%] font-semibold md:text-lg lg:text-xl"> {amountCalculation > 0 ? Number(amountCalculation).toLocaleString('en-US') : 0}{currency === 'USD' ? '$' : '៛'} </div>
                            </div>
                        </div>   
                    </div>
                    {/* Information Section */}
                    <div className="flex mt-5">
                        {/* Button Section */}
                        <div className="flex items-center w-full justify-center">
                            <div className="w-[80%]">
                                {/* Keypad grid */}
                                <div className="grid grid-cols-3 gap-3 w-full">
                                    {/* Number buttons */}
                                    {['7', '8', '9', '4', '5', '6', '1', '2', '3'].map((num) => (
                                    <button
                                        key={num}
                                        onClick={() => handleButtonClick(num)}
                                        className="py-5 text-xl bg-white border rounded shadow font-semibold"
                                    >
                                        {num}
                                    </button>
                                    ))}
                                </div>
                                <div className="grid grid-cols-4 gap-3 w-full pt-3">
                                    {['00', '0', '.'].map((num) => (
                                    <button
                                        key={num}
                                        onClick={() => handleButtonClick(num)}
                                        className="py-5 text-xl bg-white border rounded shadow font-semibold"
                                    >
                                        {num}
                                    </button>
                                    ))}
                                    <button
                                        onClick={handleDelete}
                                        className="p-4 text-lg bg-white border rounded shadow"
                                    >
                                    {/* Backspace button */}
                                    ←
                                    </button>
                                    
                                </div>
                            </div>
                            <div className="flex flex-col ml-3 w-[17%]">
                            {/* Special buttons */}
                                <div className="w-full flex flex-col">
                                    <button
                                    onClick={handleCurrencyToggle}
                                    className="px-4 justify-center flex py-4 mb-3 text-lg bg-white border rounded shadow"
                                    >
                                        {/* Currency toggle */}
                                        {currency === 'USD' ? 
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-7">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                            </svg>
                                        : <span className="font-semibold text-2xl">៛</span>}
                                    </button>

                                        <button
                                        onClick={handlePaymentMethod}
                                        className={`justify-center flex px-4 py-5 mb-3 ${paymentMethod === 'cash' ? 'bg-white' : 'bg-secondary1'} border rounded shadow`}
                                        >
                                            {/* Reset button */}
                                            <img src={acledaIcon} alt="acleda-icon" className="w-9"/>
                                        </button>
                                </div>

                                <div className="w-full flex flex-col">
                                    <button
                                    onClick={handlePaymentSubmit}
                                    className="justify-center flex px-4 py-14 text-lg bg-white hover:bg-slate-100 border rounded shadow"
                                    >
                                    {/* Submit button */}
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-8">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {alertVisible && (
                    <Stack sx={{ width: '100%', justifyContent: "flex-end",
                        alignItems: "flex-end"}}  mt={-5} spacing={2} borderRadius={2}>
                        <Alert severity={alertSeverity} sx={{fontWeight: 500, fontSize: '16px'}}>
                            {alertMessage}
                        </Alert>
                    </Stack>)}
                </div>

                {/* Dialog for Validation */}
                <Dialog open={openDialog} onClose={handleDialogClose}>
                    <DialogTitle sx={{ fontFamily: "'Kantumruy Pro', sans-serif", fontSize: '24px' }} color="#c50000">ការព្រមាន</DialogTitle>
                    <DialogContent>
                        {roomNotFoundError ? ( 
                        <DialogContentText sx={{ fontFamily: "'Kantumruy Pro', sans-serif", fontSize: '20px' }}>
                            {roomNotFoundError}
                        </DialogContentText>):
                        (
                            <DialogContentText sx={{ fontFamily: "'Kantumruy Pro', sans-serif", fontSize: '20px' }}>
                                សូមជ្រើសរើសអគារ និងបន្ទប់
                            </DialogContentText>
                        )
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogClose} color="primary"  sx={{ fontFamily: "'Inter', sans-serif", fontSize: '20px' }}>
                        OK
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog for viewing invoice */}
                <Dialog open={openInvoiceDialog} onClose={handleInvoiceDialogClose}>
                    <DialogContent>
                        {!changingSubmitData ?
                            <Invoice room_number={paymentInfo.room_number} monthYear={monthYear}/> :
                            <Invoice room_number={paymentInfo.old_room_number.toString()} monthYear={monthYear}/>
                        }
                    </DialogContent>
                </Dialog>

                {/* Dialog for edit */}
                <Dialog open={showDialog} onClose={() => setShowDialog(false)} sx={{
                    '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                        fontFamily: 'Kantumruy Pro, sans-serif'
                    }
                }}>
                    <DialogTitle>កែប្រែ</DialogTitle>
                    <DialogContent>
                    <form onSubmit={handleEditSubmit}>
                        <div className="flex space-x-4">
                            <TextField
                                margin="dense"
                                label="ទឹកខែចាស់ *"
                                name="previous_water_usage"
                                value={formData.previous_water_usage !== null ? formData.previous_water_usage : ''}
                                onChange={handleInputChange}
                                fullWidth
                                disabled
                                InputLabelProps={{
                                    style: { fontFamily: 'Kantumruy Pro' },
                                }}
                                InputProps={{
                                    style: {
                                    borderRadius: "8px",
                                    fontFamily: 'Kantumruy Pro',
                                    cursor: 'not-allowed'
                                    }
                                }}
                            />
                            <TextField
                                margin="dense"
                                label="ទឹកខែថ្មី *"
                                name="current_water_usage"
                                value={formData.current_water_usage !== null ? formData.current_water_usage : ''}
                                onChange={handleInputChange}
                                fullWidth
                                InputLabelProps={{
                                    style: { fontFamily: 'Kantumruy Pro' },
                                }}
                                InputProps={{
                                    style: {
                                    borderRadius: "8px",
                                    fontFamily: 'Kantumruy Pro',
                                    }
                                }}
                            />
                        </div>
                        <div className="flex items-center space-x-4">
                            <TextField
                                margin="dense"
                                label="ថ្លៃទឹក *"
                                name="water_usage_price"
                                value={formData.water_usage_price !== null ? formData.water_usage_price : ''}
                                onChange={handleInputChange}
                                fullWidth
                                InputLabelProps={{
                                    style: { fontFamily: 'Kantumruy Pro' },
                                }}
                                InputProps={{
                                    style: {
                                    borderRadius: "8px",
                                    fontFamily: 'Kantumruy Pro',
                                    }
                                }}
                            />
                            <TextField
                                margin="dense"
                                label="ថ្លៃភ្លើង *"
                                name="electricity_usage"
                                value={formData.electricity_usage !== null ? formData.electricity_usage : ''}
                                onChange={handleInputChange}
                                fullWidth
                                InputLabelProps={{
                                    style: { fontFamily: 'Kantumruy Pro' },
                                }}
                                InputProps={{
                                    style: {
                                    borderRadius: "8px",
                                    fontFamily: 'Kantumruy Pro',
                                    }
                                }}
                            /> {Number(formData.electricity_usage) !== 0 ? <p className="w-[30%] ml-5"> + 1000</p> : <p></p>}
                        </div>
                        <TextField
                            margin="dense"
                            label="ថ្លៃសំរាម *"
                            name="garbage"
                            value={formData.garbage !== null ? formData.garbage : ''}
                            onChange={handleInputChange}
                            fullWidth
                            InputLabelProps={{
                                style: { fontFamily: 'Kantumruy Pro' },
                            }}
                            InputProps={{
                                style: {
                                borderRadius: "8px",
                                fontFamily: 'Kantumruy Pro',
                                }
                            }}
                        />
                        <TextField
                            margin="dense"
                            label="ថ្លៃពិន័យ *"
                            name="late_penalty"
                            value={formData.late_penalty !== null ? formData.late_penalty : 0}
                            onChange={handleInputChange}
                            fullWidth
                            InputLabelProps={{
                                style: { fontFamily: 'Kantumruy Pro' },
                            }}
                            InputProps={{
                                style: {
                                borderRadius: "8px",
                                fontFamily: 'Kantumruy Pro',
                                }
                            }}
                        />
                        <TextField
                            margin="dense"
                            label="ថ្លៃផ្ញើរយានជំនិះ *"
                            name="vehicle_charge"
                            value={formData.vehicle_charge !== null ? formData.vehicle_charge : ''}
                            onChange={handleInputChange}
                            fullWidth
                            InputLabelProps={{
                                style: { fontFamily: 'Kantumruy Pro' },
                            }}
                            InputProps={{
                                style: {
                                borderRadius: "8px",
                                fontFamily: 'Kantumruy Pro',
                                }
                            }}
                        />
                        <TextField
                            margin="dense"
                            label="ថ្លៃបន្ទប់ *"
                            name="room_price_calculating"
                            value={formData.room_price_calculating !== null ? formData.room_price_calculating : ''}
                            onChange={handleInputChange}
                            fullWidth
                            InputLabelProps={{
                                style: { fontFamily: 'Kantumruy Pro' },
                            }}
                            InputProps={{
                                style: {
                                borderRadius: "8px",
                                fontFamily: 'Kantumruy Pro',
                                }
                            }}
                        />
                        <div className="flex space-x-4">
                            <TextField
                                margin="dense"
                                label="បំណុលចាស់ *"
                                name="old_debt"
                                value={formData.old_debt !== null ? formData.old_debt : ''}
                                onChange={handleInputChange}
                                fullWidth
                                InputLabelProps={{
                                    style: { fontFamily: 'Kantumruy Pro' },
                                }}
                                InputProps={{
                                    style: {
                                    borderRadius: "8px",
                                    fontFamily: 'Kantumruy Pro',
                                    }
                                }}
                            />
                            <TextField
                                margin="dense"
                                label="បំណុលសរុប *"
                                name="total_debt_update"
                                value={formData.total_debt_update !== null ? formData.total_debt_update : ''}
                                onChange={handleInputChange}
                                fullWidth
                                InputLabelProps={{
                                    style: { fontFamily: 'Kantumruy Pro' },
                                }}
                                InputProps={{
                                    style: {
                                    borderRadius: "8px",
                                    fontFamily: 'Kantumruy Pro',
                                    }
                                }}
                            />
                        </div>
                    </form>
                    </DialogContent>
                    <DialogActions sx={{marginBottom: "16px"}}>
                    <Button onClick={() => setShowDialog(false)} color="black"  
                    sx={{paddingY: "8px", paddingX: "32px", marginRight: "16px",'&:hover': {
                        backgroundColor: '#f9f9f9',
                    }, }}>
                        Cancel
                    </Button>
                    <Button onClick={handleEditSubmit} sx={{background: "#00B4D8", color: "white", paddingY: "8px", paddingX: "32px", marginRight: "16px" }}>
                        Save
                    </Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog for changing room */}
                <Dialog open={showChangingRoomDialog} onClose={() => setShowChangingRoomDialog(false)} sx={{
                    '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                        fontFamily: 'Kantumruy Pro, sans-serif'
                    }
                }}>
                    <DialogTitle sx={{fontSize: '24px'}}>ប្តូរបន្ទប់</DialogTitle>
                    <DialogContent>
                        <p className="text-lg">ប្តូរអ្នកជួលពីបន្ទប់ {paymentInfo.room_number} ទៅបន្ទប់ ៖</p><br />
                    <form onSubmit={handleChangingRoomSubmit}>
                        <TextField
                            margin="dense"
                            label="លេខបន្ទប់ *"
                            name="newRoomNumber"
                            value={newRoomNumber}
                            onChange={handleNewRoomNumber}
                            fullWidth
                            InputLabelProps={{
                                style: { fontFamily: 'Kantumruy Pro' },
                            }}
                            InputProps={{
                                style: {
                                borderRadius: "8px",
                                fontFamily: 'Kantumruy Pro',
                                }
                            }}
                        />
                    </form>
                    </DialogContent>
                    <DialogActions sx={{marginBottom: "16px"}}>
                    <Button onClick={() => setShowChangingRoomDialog(false)} color="black"  
                    sx={{paddingY: "8px", paddingX: "32px", marginRight: "16px",'&:hover': {
                        backgroundColor: '#f9f9f9',
                    }, }}>
                        Cancel
                    </Button>
                    <Button onClick={handleShowChangingRoomEditDataDialogOpen} sx={{background: "#00B4D8", color: "white", paddingY: "8px", paddingX: "32px", marginRight: "16px" }}>
                        Save
                    </Button>
                    </DialogActions>
                </Dialog>

                    {/* Dialog for changing data before exiting */}
                    <Dialog open={showChangingRoomEditDataDialog} onClose={() => setShowChangingRoomEditDataDialog(false)} sx={{
                        '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                            fontFamily: 'Kantumruy Pro, sans-serif'
                        }
                    }}>
                        <DialogTitle>កែប្រែទិន្នន័យ</DialogTitle>
                        <DialogContent>
                            <form onSubmit={handleChangingRoomSubmit}>
                                <TextField
                                    margin="dense"
                                    label="ទឹកខែចាស់ *"
                                    name="previous_water_usage"
                                    value={changingRoomFormData.previous_water_usage !== null ? changingRoomFormData.previous_water_usage : ''}
                                    onChange={handleChangingRoomInputChange}
                                    fullWidth
                                    disabled
                                    InputLabelProps={{
                                        style: { fontFamily: 'Kantumruy Pro' },
                                    }}
                                    InputProps={{
                                        style: {
                                        borderRadius: "8px",
                                        fontFamily: 'Kantumruy Pro',
                                        cursor: 'not-allowed'
                                        }
                                    }}
                                />
                                <TextField
                                    margin="dense"
                                    label="ទឹកខែថ្មី *"
                                    name="current_water_usage"
                                    value={changingRoomFormData.current_water_usage !== null ? changingRoomFormData.current_water_usage : ''}
                                    onChange={handleChangingRoomInputChange}
                                    fullWidth
                                    InputLabelProps={{
                                        style: { fontFamily: 'Kantumruy Pro' },
                                    }}
                                    InputProps={{
                                        style: {
                                        borderRadius: "8px",
                                        fontFamily: 'Kantumruy Pro',
                                        }
                                    }}
                                />
                                <div className="flex items-center">
                                    <TextField
                                        margin="dense"
                                        label="ថ្លៃភ្លើង *"
                                        name="electricity_usage"
                                        value={changingRoomFormData.electricity_usage !== null ? changingRoomFormData.electricity_usage : ''}
                                        onChange={handleChangingRoomInputChange}
                                        fullWidth
                                        InputLabelProps={{
                                            style: { fontFamily: 'Kantumruy Pro' },
                                        }}
                                        InputProps={{
                                            style: {
                                            borderRadius: "8px",
                                            fontFamily: 'Kantumruy Pro',
                                            }
                                        }}
                                    /> <p className="w-[20%] ml-5"> + 1000</p>
                                </div>
                            </form>
                        </DialogContent>
                        <DialogActions sx={{marginBottom: "16px"}}>
                        <Button onClick={() => setShowChangingRoomEditDataDialog(false)} color="black"  
                        sx={{paddingY: "8px", paddingX: "32px", marginRight: "16px",'&:hover': {
                            backgroundColor: '#f9f9f9',
                        }, }}>
                            Cancel
                        </Button>
                        <Button onClick={handleChangingRoomSubmit} sx={{background: "#00B4D8", color: "white", paddingY: "8px", paddingX: "32px", marginRight: "16px" }}>
                            {submitLoading ? "Saving..." : "Save"}
                        </Button>
                        </DialogActions>
                    </Dialog>

                {/* Dialog for exiting room */}
                <Dialog open={showExitingRoomDialog} onClose={() => setShowExitingRoomDialog(false)} sx={{
                    '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                        fontFamily: 'Kantumruy Pro, sans-serif'
                    }
                }}>
                    <DialogTitle sx={{fontSize: '24px', color: 'red'}}>ចាកចេញ</DialogTitle>
                    <DialogContent>
                        <p className="text-lg">តើអ្នកជួលនៅបន្ទប់ <strong className="text-red-600">{paymentInfo.room_number}</strong> ប្រាកដជាចង់ចាកចេញមែនទេ?</p><br />
                    </DialogContent>
                    <DialogActions sx={{marginBottom: "16px"}}>
                    <Button onClick={() => setShowExitingRoomDialog(false)} color="black"  
                    sx={{paddingY: "8px", paddingX: "32px", marginRight: "16px",'&:hover': {
                        backgroundColor: '#f9f9f9',
                    }, }}>
                        Cancel
                    </Button>
                    <Button onClick={handleShowExitingRoomChangingDataOpen} sx={{background: "#00B4D8", color: "white", paddingY: "8px", paddingX: "32px", marginRight: "16px" }}>
                        Confirm
                    </Button>
                    </DialogActions>
                </Dialog>

                    {/* Dialog for changing data before exiting */}
                    <Dialog open={showExitingRoomChangingDataDialog} onClose={() => setShowExitingRoomChangingDataDialog(false)} sx={{
                        '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                            fontFamily: 'Kantumruy Pro, sans-serif'
                        }
                    }}>
                        <DialogTitle>កែប្រែទិន្នន័យ</DialogTitle>
                        <DialogContent>
                            <form onSubmit={handleExitingSubmit}>
                                <TextField
                                    margin="dense"
                                    label="ទឹកខែចាស់ *"
                                    name="previous_water_usage"
                                    value={exitingDataFormData.previous_water_usage !== null ? exitingDataFormData.previous_water_usage : ''}
                                    onChange={handleExitingRoomInputChange}
                                    fullWidth
                                    disabled
                                    InputLabelProps={{
                                        style: { fontFamily: 'Kantumruy Pro' },
                                    }}
                                    InputProps={{
                                        style: {
                                        borderRadius: "8px",
                                        fontFamily: 'Kantumruy Pro',
                                        cursor: 'not-allowed'
                                        }
                                    }}
                                />
                                <TextField
                                    margin="dense"
                                    label="ទឹកខែថ្មី *"
                                    name="current_water_usage"
                                    value={exitingDataFormData.current_water_usage !== null ? exitingDataFormData.current_water_usage : ''}
                                    onChange={handleExitingRoomInputChange}
                                    fullWidth
                                    InputLabelProps={{
                                        style: { fontFamily: 'Kantumruy Pro' },
                                    }}
                                    InputProps={{
                                        style: {
                                        borderRadius: "8px",
                                        fontFamily: 'Kantumruy Pro',
                                        }
                                    }}
                                />
                                <div className="flex items-center">
                                    <TextField
                                        margin="dense"
                                        label="ថ្លៃភ្លើង *"
                                        name="electricity_usage"
                                        value={exitingDataFormData.electricity_usage !== null ? exitingDataFormData.electricity_usage : ''}
                                        onChange={handleExitingRoomInputChange}
                                        fullWidth
                                        InputLabelProps={{
                                            style: { fontFamily: 'Kantumruy Pro' },
                                        }}
                                        InputProps={{
                                            style: {
                                            borderRadius: "8px",
                                            fontFamily: 'Kantumruy Pro',
                                            }
                                        }}
                                    /> <p className="w-[20%] ml-5"> + 1000</p>
                                </div>
                            </form>
                        </DialogContent>
                        <DialogActions sx={{marginBottom: "16px"}}>
                        <Button onClick={() => setShowExitingRoomChangingDataDialog(false)} color="black"  
                        sx={{paddingY: "8px", paddingX: "32px", marginRight: "16px",'&:hover': {
                            backgroundColor: '#f9f9f9',
                        }, }}>
                            Cancel
                        </Button>
                        <Button onClick={handleExitingSubmit} sx={{background: "#00B4D8", color: "white", paddingY: "8px", paddingX: "32px", marginRight: "16px" }}>
                            {submitLoading ? "Saving..." : "Save"}
                        </Button>
                        </DialogActions>
                    </Dialog>

                {/* Dialog for entering room */}
                <Dialog open={showEnteringRoomDialog} onClose={() => setShowEnteringRoomDialog(false)} sx={{
                    '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                        fontFamily: 'Kantumruy Pro, sans-serif'
                    }
                }}>
                    <DialogTitle sx={{fontSize: '24px', color: 'red'}}>ចូល</DialogTitle>
                    <DialogContent>
                        <p className="text-lg">តើអ្នកប្រាកដជាចង់បញ្ចូលអ្នកជួលនៅបន្ទប់ <strong className="text-red-600">{paymentInfo.room_number}</strong> មែនទេ?</p><br />
                    </DialogContent>
                    <DialogActions sx={{marginBottom: "16px"}}>
                    <Button onClick={() => setShowEnteringRoomDialog(false)} color="black"  
                    sx={{paddingY: "8px", paddingX: "32px", marginRight: "16px",'&:hover': {
                        backgroundColor: '#f9f9f9',
                    }, }}>
                        Cancel
                    </Button>
                    <Button onClick={handleEnteringRoomSubmit} sx={{background: "#00B4D8", color: "white", paddingY: "8px", paddingX: "32px", marginRight: "16px" }}>
                        Confirm
                    </Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog for error */}
                <Dialog open={showErrorDialog} onClose={() => setShowErrorDialog(false)} sx={{
                '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                    fontFamily: 'Kantumruy Pro, sans-serif',
                }
                }}>
                    <DialogTitle sx={{color: "red"}}>Error</DialogTitle>
                    <DialogContent>
                        <div style={{ whiteSpace: 'pre-line' }}>
                            {errorMessage}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowErrorDialog(false)} color="secondary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>)}
        </div>
    )
}